import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { GrantDiscordAccessInput_InputAdapter_instance3msvaqtmlu6i as GrantDiscordAccessInput_InputAdapter_instance } from '../type/adapter/GrantDiscordAccessInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessMutation_VariablesAdapterClass;
function GrantDiscordAccessMutation_VariablesAdapter() {
  if (GrantDiscordAccessMutation_VariablesAdapterClass === VOID) {
    class $ {
      d6h(writer, value, customScalarAdapters, withDefaultValues) {
        writer.h48('input');
        obj(GrantDiscordAccessInput_InputAdapter_instance).f40(writer, customScalarAdapters, value.c6h_1);
      }
    }
    initMetadataForObject($, 'GrantDiscordAccessMutation_VariablesAdapter');
    GrantDiscordAccessMutation_VariablesAdapterClass = $;
  }
  return GrantDiscordAccessMutation_VariablesAdapterClass;
}
var GrantDiscordAccessMutation_VariablesAdapter_instance;
function GrantDiscordAccessMutation_VariablesAdapter_getInstance() {
  return GrantDiscordAccessMutation_VariablesAdapter_instance;
}
//region block: init
GrantDiscordAccessMutation_VariablesAdapter_instance = new (GrantDiscordAccessMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  GrantDiscordAccessMutation_VariablesAdapter_instance as GrantDiscordAccessMutation_VariablesAdapter_instance37ervv779xwn4,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutation_VariablesAdapter.mjs.map
